/*
  PASTE INSTRUCTIONS
  ------------------
  Shopify Admin > Online Store > Themes > Edit code > assets/theme.js
  Replace the ENTIRE file with everything below this line.

  This is your existing theme.js with the free-gift cart drawer added.
  All your original functions (sticky nav, mobile nav, thumbnail gallery,
  email form, smooth scroll) are unchanged. The old plain
  "updateCartCount()" fetch has been folded into the new refreshCart().

  Gift threshold ($110) comes from window.LylaGiftThreshold, set in
  theme.liquid. Gift products come from the JSON embedded by the
  cart-drawer snippet, sourced from the "free-gift-tier" collection.

  Paste this ENTIRE file, including this comment block, as-is.
*/

document.addEventListener('DOMContentLoaded', function () {

  /* ============================================
     CART DRAWER + FREE GIFT PICKER
     ============================================ */

  var GIFT_THRESHOLD = window.LylaGiftThreshold || 11000; // cents
  var SHIP_THRESHOLD = window.LylaShipThreshold || 16000; // cents (free express shipping tier)
  var GIFT_PRODUCTS = [];
  var giftDataEl = document.getElementById('lyla-gift-products-data');
  if (giftDataEl) {
    try {
      GIFT_PRODUCTS = JSON.parse(giftDataEl.textContent);
    } catch (e) {
      GIFT_PRODUCTS = [];
    }
  }

  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  var toggleBtn = document.getElementById('cart-drawer-toggle');
  var closeBtn = document.getElementById('cart-drawer-close');

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  var CART_ICON_BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';
  var CART_ICON_GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="9" width="16" height="11" rx="1"/><path d="M4 9h16M12 9v11"/><path d="M8 9c-1.5 0-2.5-1-2.5-2.5S6.5 4 8 4c2 0 4 2 4 5"/><path d="M16 9c1.5 0 2.5-1 2.5-2.5S17.5 4 16 4c-2 0-4 2-4 5"/></svg>';
  var CART_ICON_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="8" width="11" height="8"/><path d="M13 11h4l3 3v2h-7z"/><circle cx="6.5" cy="18" r="1.6"/><circle cx="16.5" cy="18" r="1.6"/></svg>';
  var CART_ICON_FLOWER = '<svg viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="6.5" r="4"/><circle cx="12" cy="17.5" r="4"/><circle cx="6.5" cy="12" r="4"/><circle cx="17.5" cy="12" r="4"/><circle cx="12" cy="12" r="3" fill="var(--ivory, #fdfaf8)"/></svg>';
  var GIFT_DIVIDER = '<div class="cart-drawer__gift-divider"><span class="cart-drawer__gift-divider-line"></span><span class="cart-drawer__gift-divider-icon">' + CART_ICON_FLOWER + '</span><span class="cart-drawer__gift-divider-line"></span></div>';

  function buildGiftMessage(totalPrice, eligibleGift, eligibleShip, hasGiftLine) {
    if (!eligibleGift) {
      return (
        '<p class="cart-drawer__gift-progress-text cart-drawer__gift-progress-text--active">Add ' + formatMoney(GIFT_THRESHOLD - totalPrice) + ' for your complimentary gift</p>' +
        GIFT_DIVIDER +
        '<p class="cart-drawer__gift-progress-text cart-drawer__gift-progress-text--muted">and free express shipping from ' + formatMoney(SHIP_THRESHOLD) + '</p>'
      );
    }
    if (!eligibleShip) {
      return (
        '<p class="cart-drawer__gift-progress-text cart-drawer__gift-progress-text--muted">Your complimentary gift is unlocked</p>' +
        GIFT_DIVIDER +
        '<p class="cart-drawer__gift-progress-text cart-drawer__gift-progress-text--active">Add ' + formatMoney(SHIP_THRESHOLD - totalPrice) + ' for free express shipping</p>'
      );
    }
    return '<p class="cart-drawer__gift-progress-text cart-drawer__gift-progress-text--active">Everything unlocked' + (hasGiftLine ? '' : ' - choose your gift below') + '</p>';
  }

  function buildGiftProgress(percent, giftMarkPercent, giftReached, shipReached, messageHtml) {
    return (
      '<div class="cart-drawer__gift-progress' + (shipReached ? ' is-complete' : '') + '">' +
        messageHtml +
        '<div class="cart-drawer__gift-track-wrap">' +
          '<div class="cart-drawer__gift-progress-track">' +
            '<div class="cart-drawer__gift-progress-fill" style="width:' + percent + '%"></div>' +
          '</div>' +
          '<span class="cart-drawer__gift-badge cart-drawer__gift-badge--start" style="left:0%">' + CART_ICON_BAG + '</span>' +
          '<span class="cart-drawer__gift-badge cart-drawer__gift-badge--gift' + (giftReached ? ' is-reached' : '') + '" style="left:' + giftMarkPercent + '%">' + CART_ICON_GIFT + '</span>' +
          '<span class="cart-drawer__gift-badge cart-drawer__gift-badge--ship' + (shipReached ? ' is-reached' : '') + '" style="left:100%">' + CART_ICON_TRUCK + '</span>' +
        '</div>' +
      '</div>'
    );
  }

  function isGiftLine(item) {
    return !!(item.properties && (item.properties._free_gift === 'true' || item.properties._free_gift === true));
  }

  function openDrawer() {
    if (!drawer || !overlay) return;
    overlay.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
    });
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    refreshCart();
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    setTimeout(function () {
      if (!overlay.classList.contains('is-open')) overlay.hidden = true;
    }, 250);
  }

  if (toggleBtn) {
    toggleBtn.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  }
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function updateHeaderCount(cart) {
    var bags = document.querySelectorAll('.site-header__cart');
    bags.forEach(function (el) {
      el.textContent = 'Bag (' + cart.item_count + ')';
    });
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateHeaderCount(cart);
        renderDrawer(cart);
      });
  }

  function removeLine(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  function renderDrawer(cart) {
    if (!drawer) return;

    var itemsEl = document.getElementById('cart-drawer-items');
    var emptyEl = document.getElementById('cart-drawer-empty');
    var subtotalEl = document.getElementById('cart-drawer-subtotal');
    var bannerEl = document.getElementById('cart-drawer-gift-banner');
    var pickerEl = document.getElementById('cart-drawer-gift-picker');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      if (pickerEl) pickerEl.hidden = true;
      if (bannerEl) {
        var giftMark0 = Math.round((GIFT_THRESHOLD / SHIP_THRESHOLD) * 100);
        bannerEl.innerHTML = buildGiftProgress(0, giftMark0, false, false, buildGiftMessage(0, false, false, false));
      }
      if (subtotalEl) subtotalEl.textContent = formatMoney(0);
      return;
    }
    if (emptyEl) emptyEl.hidden = true;

    itemsEl.innerHTML = cart.items.map(function (item) {
      var gift = isGiftLine(item);
      var titleLine = item.product_title + (item.variant_title ? ' - ' + item.variant_title : '');
      if (gift) {
        var giftPriceHtml = item.final_line_price === 0
          ? (item.original_line_price > 0
              ? '<s>' + formatMoney(item.original_line_price) + '</s> Free'
              : 'Free')
          : formatMoney(item.final_line_price);
        return (
          '<div class="cart-drawer__item is-gift" data-line-key="' + item.key + '">' +
            '<img class="cart-drawer__item-image" src="' + item.image + '" alt="' + titleLine + '">' +
            '<div class="cart-drawer__item-details">' +
              '<span class="cart-drawer__item-gift-label">Free Gift</span><br>' +
              '<p class="cart-drawer__item-title">' + titleLine + '</p>' +
              '<div class="cart-drawer__item-price">' + giftPriceHtml + '</div>' +
              '<button type="button" class="cart-drawer__item-remove" data-remove-key="' + item.key + '">Remove gift</button>' +
            '</div>' +
          '</div>'
        );
      }
      return (
        '<div class="cart-drawer__item" data-line-key="' + item.key + '">' +
          '<img class="cart-drawer__item-image" src="' + item.image + '" alt="' + titleLine + '">' +
          '<div class="cart-drawer__item-details">' +
            '<p class="cart-drawer__item-title">' + titleLine + '</p>' +
            '<div class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>' +
            '<div class="cart-drawer__item-qty">' +
              '<button type="button" class="cart-drawer__qty-btn" data-qty-key="' + item.key + '" data-qty-change="-1">-</button>' +
              '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
              '<button type="button" class="cart-drawer__qty-btn" data-qty-key="' + item.key + '" data-qty-change="1">+</button>' +
              '<button type="button" class="cart-drawer__item-remove" data-remove-key="' + item.key + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    var currentGiftLine = cart.items.find(isGiftLine);
    var eligibleGift = cart.total_price >= GIFT_THRESHOLD;
    var eligibleShip = cart.total_price >= SHIP_THRESHOLD;
    var barMax = SHIP_THRESHOLD;
    var percent = Math.min(100, Math.round((cart.total_price / barMax) * 100));
    var giftMarkPercent = Math.round((GIFT_THRESHOLD / barMax) * 100);

    if (bannerEl) {
      var messageHtml = buildGiftMessage(cart.total_price, eligibleGift, eligibleShip, !!currentGiftLine);
      bannerEl.innerHTML = buildGiftProgress(percent, giftMarkPercent, eligibleGift, eligibleShip, messageHtml);
    }

    if (!eligibleGift) {
      if (currentGiftLine) {
        removeLine(currentGiftLine.key).then(refreshCart);
        return;
      }
      if (pickerEl) pickerEl.hidden = true;
      return;
    }

    if (pickerEl) {
      if (GIFT_PRODUCTS.length) {
        pickerEl.hidden = false;
        pickerEl.innerHTML =
          '<p class="cart-drawer__gift-picker-title">Choose your free gift</p>' +
          '<div class="cart-drawer__gift-options">' +
          GIFT_PRODUCTS.map(function (gift) {
            var selected = currentGiftLine && currentGiftLine.variant_id === gift.variant_id;
            return (
              '<div class="cart-drawer__gift-option' + (selected ? ' is-selected' : '') + '" data-gift-variant="' + gift.variant_id + '">' +
                '<img src="' + gift.image + '" alt="' + gift.title + '">' +
                '<div>' + gift.title + '</div>' +
              '</div>'
            );
          }).join('') +
          '</div>';
      } else {
        pickerEl.hidden = true;
      }
    }
  }

  function selectGift(variantId) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var existingGift = cart.items.find(isGiftLine);

        var removeExisting = existingGift ? removeLine(existingGift.key) : Promise.resolve();

        removeExisting.then(function () {
          if (existingGift && existingGift.variant_id === variantId) {
            refreshCart();
            return;
          }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1, properties: { _free_gift: 'true' } }]
            })
          }).then(refreshCart);
        });
      });
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-qty-key]');
    if (qtyBtn) {
      var key = qtyBtn.getAttribute('data-qty-key');
      var change = parseInt(qtyBtn.getAttribute('data-qty-change'), 10);
      var row = qtyBtn.closest('.cart-drawer__item');
      var qtyEl = row ? row.querySelector('.cart-drawer__qty-value') : null;
      var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      var newQty = Math.max(0, currentQty + change);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      }).then(refreshCart);
      return;
    }

    var removeBtn = e.target.closest('[data-remove-key]');
    if (removeBtn) {
      removeLine(removeBtn.getAttribute('data-remove-key')).then(refreshCart);
      return;
    }

    var giftOption = e.target.closest('[data-gift-variant]');
    if (giftOption) {
      selectGift(parseInt(giftOption.getAttribute('data-gift-variant'), 10));
      return;
    }
  });

  /* --- ADD TO CART AJAX --- */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(productForm);
      const btn = productForm.querySelector('.product-page__add');
      btn.textContent = 'Adding…';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(r => r.json())
      .then(() => {
        btn.textContent = 'Added to bag ✓';
        btn.style.background = 'var(--gold)';
        refreshCart();
        openDrawer();
        setTimeout(() => {
          btn.textContent = 'Add to bag';
          btn.style.background = '';
          btn.disabled = false;
        }, 2500);
      })
      .catch(() => {
        btn.textContent = 'Add to bag';
        btn.disabled = false;
      });
    });
  }

  /* --- CART QUANTITY UPDATE (cart page) --- */
  const cartForm = document.querySelector('form[action="/cart"]');
  if (cartForm) {
    const inputs = cartForm.querySelectorAll('input[name="updates[]"]');
    inputs.forEach(input => {
      input.addEventListener('change', function () {
        cartForm.submit();
      });
    });
  }

  /* --- STICKY NAV SHADOW ON SCROLL --- */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 20px rgba(122,95,92,0.06)';
      } else {
        header.style.boxShadow = 'none';
      }
    }, { passive: true });
  }

  /* --- MOBILE NAV TOGGLE --- */
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      const isOpen = mobileNav.style.display === 'block';
      mobileNav.style.display = isOpen ? 'none' : 'block';
      menuBtn.setAttribute('aria-expanded', !isOpen);
    });
  }

  /* --- PRODUCT THUMBNAIL GALLERY --- */
  const thumbs = document.querySelectorAll('.product-page__thumb');
  const mainImg = document.getElementById('main-img');
  if (thumbs.length && mainImg) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', function () {
        thumbs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        const newSrc = this.querySelector('img').src.replace('200x200', '1200x1500');
        mainImg.src = newSrc;
      });
    });
  }

  /* --- EMAIL FORM FEEDBACK --- */
  const emailForm = document.querySelector('.email-signup__form');
  if (emailForm) {
    emailForm.addEventListener('submit', function () {
      const btn = emailForm.querySelector('.email-signup__btn');
      btn.textContent = 'Subscribed ✓';
      btn.style.background = 'var(--gold)';
    });
  }

  /* --- SMOOTH SCROLL ANCHOR LINKS --- */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
